document.addEventListener("DOMContentLoaded", function () {
      // Verificar si la URL contiene 'pages/eyewear-collections'
      if (window.location.pathname.includes("pages/eyewear-collections")) {
          
        document.querySelectorAll("h1").forEach(h1 => {
              if (h1.textContent.trim() === "COLLECTIONS") {
                  h1.textContent = "Eyewear Collections";
              }
          });

       
          document.querySelectorAll(".disappear").forEach(element => {
              element.style.display = "none";
          });

  
          document.querySelectorAll(".ml-custom").forEach(element => {
              element.style.marginLeft = "30px";
          });

       
          document.querySelectorAll(".pt-0").forEach(element => {
              element.style.paddingTop = "0";
          });

        document.querySelectorAll(".custom-padding").forEach(element => {
              element.style.paddingTop = "20px";
          });

   
      }
});
